module.exports = __webpack_public_path__ + "Example-Feedback.png?7eb088ebeab38abb2c62408b92e34dbf";


//////////////////
// WEBPACK FOOTER
// ./static/Example-Feedback.png
// module id = 349
// module chunks = 0